import ModalRatePlanDetails from './ModalRatePlanDetails';
export default ModalRatePlanDetails;
